<template>
  <v-select
    v-model="selected"
    :items="items"
    :loading="loading"
    :label="label"
    clearable
    clear-icon="close"
    multiple
    outline
    chips
    small-chips
    :height="46"
    hide-details
    no-data-text="Данные не выбраны"
    return-object
    @click:clear="clear"
  >
    <template
      v-slot:selection="{ item, index }"
      class="pt-0"
    >
      <v-chip
        v-if="index === 0"
        small
      >
        <span>{{ item.text }}</span>
      </v-chip>
      <span
        v-if="index === 1"
        class="grey--text caption"
      >{{ `+${selected.length - 1} стран(ы)` }}</span>
    </template>
    <template
      v-slot:prepend-item
      class="pt-5"
    >
      <v-list-tile
        ripple
        class="list-fixed-header"
      >
        <v-list-tile-action>
          <v-icon
            size="19"
            :color="selected.length > 0 ? 'blue darken-2' : ''"
            @click="toggle"
          >
            {{ icon }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Выбрать все</v-list-tile-title>
        </v-list-tile-content>
        <v-spacer />
        <v-list-tile-action class="ml-4">
          <v-layout>
            <v-btn
              small
              color="primary"
              class="mr-2"
              flat
              @click="change"
            >
              Применить
            </v-btn>
            <v-btn
              small
              flat
              @click="cancel"
            >
              Отменить
            </v-btn>
          </v-layout>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider class="mt-2" />
    </template>
  </v-select>
</template>
<script>
import * as referenceApi from "../../backend/referenceApi.js";
export default {
  props: [
    "value",
    "label",
    "rules",
    "resource",
  ],
  data() {
    return {
      selected: [],
      items: [],
      loading: false,
      tempSelected: [],
    };
  },
  computed: {
    isAllSelected() {
      return this.selected.length === this.items.length;
    },
    isAnySelected() {
      return this.selected.length > 0 && !this.isAllSelected;
    },
    icon() {
      if (this.isAllSelected) {return "disabled_by_default";}
      if (this.isAnySelected) {return "indeterminate_check_box";}
      return "check_box_outline_blank";
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.selected = [...new Set(val)];
          this.items = [...new Set(val)];
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      async(newVal) => {
        if (newVal) {
          await this.fetchAll();
        }
      },
    );
  },
  methods: {
    async fetchAll() {
      this.loading = true;
      this.items = [];
      this.items = await referenceApi.getReferencies(this.resource);
      this.loading = false;
    },
    change() {
      this.$children[0].$data.isMenuActive = false;
      this.tempSelected = this.selected;
      this.$emit("input", this.selected);
    },
    clear() {
      this.selected = [];
      this.tempSelected = [];
      this.$children[0].$data.isMenuActive = false;
      this.$emit("input", this.selected);
    },
    cancel() {
      this.selected = this.tempSelected;
      this.$children[0].$data.isMenuActive = false;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.isAllSelected) {
          this.selected = [];
        } else {
          this.selected = this.items.slice();
        }
      });
    },
  },
};
</script>
<style>
  .v-list>div[role='listitem']:first-child.list-fixed-header {
    position: sticky;
    top: 0;
    z-index: 9999;
    background: #fff;
    padding: 10px 0;
  }
</style>